import { configureStore } from '@reduxjs/toolkit';

import { authApi } from '@/api/auth/api';
import { dictionariesApi } from '@/api/dictionaries/api';
import { farmingApi } from '@/api/farming/api';
import { organizationsApi } from '@/api/organizations/api';
import { pathologyApi } from '@/api/pathology/api';
import { pharmacyApi } from '@/api/pharmacy/api';
import { reportApi } from '@/api/report/api';
import { rolesApi } from '@/api/roles/api';
import { usersApi } from '@/api/users/api';
import { vaccinationControlApi } from '@/api/vaccination/control/api';
import { vaccinationProtocolsApi } from '@/api/vaccination/protocols/api';
import { vaccinationRegistryApi } from '@/api/vaccination/registry/api';
import { vaccinationTaskApi } from '@/api/vaccination/task/api';
import { filtersSlice } from '@/store/filtersSlice';
import { sortSlice } from '@/store/sortSlice';

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [dictionariesApi.reducerPath]: dictionariesApi.reducer,
    [vaccinationRegistryApi.reducerPath]: vaccinationRegistryApi.reducer,
    [vaccinationProtocolsApi.reducerPath]: vaccinationProtocolsApi.reducer,
    [vaccinationControlApi.reducerPath]: vaccinationControlApi.reducer,
    [vaccinationTaskApi.reducerPath]: vaccinationTaskApi.reducer,
    [farmingApi.reducerPath]: farmingApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [pharmacyApi.reducerPath]: pharmacyApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [pathologyApi.reducerPath]: pathologyApi.reducer,
    [filtersSlice.name]: filtersSlice.reducer,
    [sortSlice.name]: sortSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      dictionariesApi.middleware,
      vaccinationRegistryApi.middleware,
      vaccinationProtocolsApi.middleware,
      vaccinationControlApi?.middleware,
      vaccinationTaskApi?.middleware,
      farmingApi.middleware,
      organizationsApi.middleware,
      usersApi.middleware,
      reportApi.middleware,
      pharmacyApi?.middleware,
      rolesApi?.middleware,
      pathologyApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
